// access-matrix.ts — Matrice d'accès projets × utilisateurs (lecture seule).
// Permission users.write (gérée côté router/backend).
import { req } from './_internals.js';

export const accessMatrixApi = {
  getAccessMatrix: () => req('GET', '/access-matrix'),
};
